/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RecurringInputs */

const fr_recurring = /** @type {(inputs: RecurringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récurrent`)
};

/**

* @param {RecurringInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const recurring = /** @type {((inputs?: RecurringInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RecurringInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_recurring(inputs)
});